<script lang="ts">
  import { AppState } from '../../../etc/stores';

  const { primary200, primary600 } = $AppState.theme.colors;
</script>

<svg
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="40" height="40" rx="8" fill={primary600} />
  <path
    d="M28.4446 26.5925C28.9355 26.5925 29.3334 26.1945 29.3334 25.7036C29.3334 25.2127 28.9355 24.8147 28.4446 24.8147C27.9536 24.8147 27.5557 25.2127 27.5557 25.7036C27.5557 26.1945 27.9536 26.5925 28.4446 26.5925Z"
    fill={primary200}
    stroke={primary200}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M24.8889 28.6664C25.3798 28.6664 25.7778 28.2685 25.7778 27.7776C25.7778 27.2866 25.3798 26.8887 24.8889 26.8887C24.398 26.8887 24 27.2866 24 27.7776C24 28.2685 24.398 28.6664 24.8889 28.6664Z"
    fill={primary200}
    stroke={primary200}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M28.4446 30.7402C28.9355 30.7402 29.3334 30.3422 29.3334 29.8513C29.3334 29.3604 28.9355 28.9624 28.4446 28.9624C27.9536 28.9624 27.5557 29.3604 27.5557 29.8513C27.5557 30.3422 27.9536 30.7402 28.4446 30.7402Z"
    fill={primary200}
    stroke={primary200}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M25.6562 28.2246L27.68 29.4039"
    stroke={primary200}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M27.677 26.1506L25.6562 27.3299"
    stroke={primary200}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M20.4922 16.6092L20.4456 15.8403C20.3057 13.8473 21.5336 12.0269 23.4766 11.3208C24.1917 11.0697 25.4041 11.0383 26.1968 11.258C26.5077 11.3522 27.0984 11.666 27.5181 11.9485L28.2797 12.4663L29.1191 12.1996C29.5854 12.0583 30.2072 11.8229 30.487 11.666C30.7512 11.5248 30.9844 11.4463 30.9844 11.4934C30.9844 11.7602 30.4093 12.6703 29.9274 13.1725C29.2745 13.8787 29.4611 13.9414 30.7823 13.4707C31.5751 13.2039 31.5906 13.2039 31.4352 13.502C31.3419 13.659 30.86 14.2082 30.3471 14.7104C29.4766 15.5735 29.43 15.6676 29.43 16.3895C29.43 17.5037 28.9015 19.8262 28.373 21.0973C28.204 21.5088 28.0018 21.9227 27.772 22.3322C27.4148 22.26 27.0451 22.2222 26.6667 22.2222C23.5984 22.2222 21.1111 24.7095 21.1111 27.7778C21.1111 27.901 21.1151 28.0234 21.123 28.1447C18.5436 29.0506 15.5827 29.1429 13 28.3473C11.8964 28.002 10 27.1233 10 26.9663C10 26.9192 10.5751 26.8565 11.2746 26.8408C12.7357 26.8094 14.1969 26.4014 15.4404 25.6795L16.2798 25.1774L15.316 24.8478C13.9482 24.377 12.7202 23.2942 12.4093 22.2742C12.3161 21.9447 12.3471 21.929 13.2176 21.929L14.1192 21.9133L13.3575 21.5524C12.4559 21.0973 11.6321 20.3283 11.228 19.5437C10.9326 18.9788 10.5596 17.5507 10.6684 17.4409C10.6995 17.3938 11.0259 17.488 11.399 17.6135C12.4715 18.0058 12.6114 17.9117 11.9896 17.2526C10.8238 16.0599 10.4663 14.2867 11.0259 12.6076L11.2902 11.8543L12.3161 12.8743C14.4145 14.9301 16.886 16.1541 19.715 16.515L20.4922 16.6092Z"
    fill={primary200}
  />
</svg>
